import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "react-router-redux";
import swal from "sweetalert";
import api from "services/api";

import {
  Creators as MultipliersActions,
  Types as MultipliersTypes,
} from "store/ducks/multipliers";

function* getMultiplierRequest(action) {
  try {
    const { id } = action.payload;
    const url = `experience/v2/points_campaigns/${id}`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierFailure());
  }
}

function* getMultipliersRequest(action) {
  try {
    const { page } = action.payload;

    const url = `/experience/v2/points_campaigns?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultipliersSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultipliersFailure());
  }
}

function* createMultiplierRequest(action) {
  try {
    const { data } = action.payload;
    const url = "experience/v2/points_campaigns";
    yield call(api.post, url, data);

    yield put(push("/points/multiplier"));
    yield call(
      swal,
      "Adicionado",
      "Campanha de pontos adicionada com sucesso!",
      "success"
    );
    yield put(MultipliersActions.createMultiplierSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível criar a campanha de pontos.",
      "error"
    );
    yield put(MultipliersActions.createMultiplierFailure());
  }
}

function* updateMultiplierRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `experience/v2/points_campaigns/${id}`;
    yield call(api.put, url, data);

    yield put(push("/points/multiplier"));
    yield call(
      swal,
      "Atualizado",
      "Campanha de pontos atualizada com sucesso!",
      "success"
    );
    yield put(MultipliersActions.updateMultiplierSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível atualizar a campanha de pontos.",
      "error"
    );
    yield put(MultipliersActions.updateMultiplierFailure());
  }
}

function* getMultiplierCategoriesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `experience/v2/voucher_categories?search=${query}&per=30`;
    const response = yield call(api.get, url);

    const { data } = response.data;

    const categories = {
      data: data.filter(
        (category) => category.attributes.external_id !== "aniversario"
      ),
    };

    yield put(MultipliersActions.getMultiplierCategoriesSuccess(categories));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierCategoriesFailure());
  }
}

function* getMultiplierChannelsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/channels?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierChannelsSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierChannelsFailure());
  }
}

function* getMultiplierRegionsRequest(action) {
  try {
    const url = `store/v2/regions?per=30`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierRegionsSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierRegionsFailure());
  }
}

function* getMultiplierStoresRequest(action) {
  try {
    const { query, region } = action.payload;
    const url = `store/v2/places`;
    const response = yield call(api.get, url, {
      params: {
        region_id: region,
        search: query,
        per: 30,
      },
    });

    yield put(MultipliersActions.getMultiplierStoresSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierStoresFailure());
  }
}

function* getMultiplierProductTypesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/product_types?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(
      MultipliersActions.getMultiplierProductTypesSuccess(response.data)
    );
  } catch (error) {
    yield put(MultipliersActions.getMultiplierProductTypesFailure());
  }
}

function* getMultiplierSectionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/sections?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierSectionsSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierSectionsFailure());
  }
}

function* getMultiplierSubSectionsRequest(action) {
  try {
    const { query, section } = action.payload;
    const url = `store/v2/sub_sections?search=${query}${
      section !== null ? `&section_id=${section}` : ""
    }&per=30`;
    const response = yield call(api.get, url);

    yield put(
      MultipliersActions.getMultiplierSubSectionsSuccess(response.data)
    );
  } catch (error) {
    yield put(MultipliersActions.getMultiplierSubSectionsFailure());
  }
}

function* getMultiplierProductsRequest(action) {
  try {
    const { query } = action.payload;

    if (query.length >= 2) {
      const url = `store/v2/products?skus=${query}&per=50`;
      const response = yield call(api.get, url);

      yield put(MultipliersActions.getMultiplierProductsSuccess(response.data));
    } else {
      yield put(MultipliersActions.getMultiplierProductsSuccess({ data: [] }));
    }
  } catch (error) {
    yield put(MultipliersActions.getMultiplierProductsFailure());
  }
}

function* getMultiplierPassionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `classification/v2/passions?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierPassionsSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierPassionsFailure());
  }
}

function* getMultiplierSellersRequest(action) {
  try {
    const url = `store/v2/sellers?per=30`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierSellersSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierSellersFailure());
  }
}

function* getMultiplierTypesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `experience/v2/voucher_configurations?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierTypesSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierTypesFailure());
  }
}

function* searchMultipliersRequest(action) {
  try {
    const { query, app_only } = action.payload;
    const url = `experience/v2/vouchers/backoffice?per=1000&type=percentage&search=${query}${
      app_only !== "" ? `&app_only=${app_only ? "true" : "false"}` : ""
    }`;
    const response = yield call(api.get, url);

    yield put(MultipliersActions.searchMultipliersSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.searchMultipliersFailure());
  }
}

function* approveMultiplierRequest(action) {
  try {
    const { id } = action.payload;
    const url = `experience/v2/points_campaigns/approve`;

    yield call(api.post, url, {
      points_campaign_id: id,
    });

    yield put(push("/points/multiplier"));
    yield call(swal, "Aprovado", "Campanha aprovada com sucesso!", "success");
    yield put(MultipliersActions.approveMultiplierSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao aprovar",
      "Não foi possível aprovar o benefício.",
      "error"
    );
    yield put(MultipliersActions.approveMultiplierFailure());
  }
}

function* repproveMultiplierRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `experience/v2/points_campaigns/reprove`;
    yield call(api.post, url, {
      points_campaign_id: id,
      ...data,
    });

    yield put(push("/points/multiplier"));
    yield call(
      swal,
      "Reprovado",
      "Campanha reprovada com sucesso!",
      "success"
    );
    yield put(MultipliersActions.repproveMultiplierSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao reprovar",
      "Não foi possível reprovar o benefício.",
      "error"
    );
    yield put(MultipliersActions.repproveMultiplierFailure());
  }
}

function* getMultiplierPlansRequest(action) {
  try {
    const url = "experience/v2/plans?page=1&per=100&gives_points_value=true";
    const response = yield call(api.get, url);

    yield put(MultipliersActions.getMultiplierPlansSuccess(response.data));
  } catch (error) {
    yield put(MultipliersActions.getMultiplierPlansFailure());
  }
}

export default function* saga() {
  yield takeLatest(MultipliersTypes.GET_REQUEST, getMultiplierRequest);
  yield takeLatest(MultipliersTypes.GET_LIST_REQUEST, getMultipliersRequest);
  yield takeLatest(MultipliersTypes.CREATE_REQUEST, createMultiplierRequest);
  yield takeLatest(MultipliersTypes.UPDATE_REQUEST, updateMultiplierRequest);
  yield takeLatest(
    MultipliersTypes.GET_CATEGORIES_REQUEST,
    getMultiplierCategoriesRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_CHANNELS_REQUEST,
    getMultiplierChannelsRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_REGIONS_REQUEST,
    getMultiplierRegionsRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_STORES_REQUEST,
    getMultiplierStoresRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_PRODUCT_TYPES_REQUEST,
    getMultiplierProductTypesRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_SECTIONS_REQUEST,
    getMultiplierSectionsRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_SUB_SECTIONS_REQUEST,
    getMultiplierSubSectionsRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_PRODUCTS_REQUEST,
    getMultiplierProductsRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_PASSIONS_REQUEST,
    getMultiplierPassionsRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_SELLERS_REQUEST,
    getMultiplierSellersRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_TYPES_REQUEST,
    getMultiplierTypesRequest
  );
  yield takeLatest(MultipliersTypes.SEARCH_REQUEST, searchMultipliersRequest);
  yield takeLatest(MultipliersTypes.APPROVE_REQUEST, approveMultiplierRequest);
  yield takeLatest(
    MultipliersTypes.REPPROVE_REQUEST,
    repproveMultiplierRequest
  );
  yield takeLatest(
    MultipliersTypes.GET_PLANS_REQUEST,
    getMultiplierPlansRequest
  );
}
